export enum ReturnTypes {
    Json,
    String,
    StatusCode
}